import myPic from "../../assets/img/herosectionprofile.png";
import bgImg from "../../assets/img/backgroundintroduction.jpg";
import { Parallax } from "react-parallax";

import { TypeAnimation } from "react-type-animation";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
const Hero = () => {
    return (
        <Parallax bgImage={bgImg} strength={600}>
            <div className=" min-h-[500px] flex items-center justify-center text-white pt-16 lg:pt-0 ">
                <div className="relative flex flex-col items-center justify-around w-full top-[48px] lg:top-auto gap-y-5 lg:flex-row ">
                 
                   <div className="flex text-black lg:text-[#eeeeee] bg-[#F9F9F9] px-1 sm:px-2 md:px-3 py-1 rounded-xl lg:p-0 lg:bg-inherit min-h-[195px]  flex-col items-center justify-center lg:justify-start lg:items-start gap-y-4 bottom-10 lg:bottom-auto w-[100%] lg:w-auto relative right-auto lg:right-4 xl:right-0 textofintro text-center">
                        <h1 className="font-bold text-[31px] sm:text-[35px] flex-wrap flex md:text-[44px] xl:text-[49px] ">
                            HEY, I'M Gulfam Haider
                        </h1>
                        <p className=" sm:text-sm md:text-base min-h-[60px]   text-[12px] w-[90%] lg:w-[534px] xl:w-[580px] ">
                            Looking for a Pro? You've found him! With expertise
                            in{" "}
                            <span className="font-bold">
                                <TypeAnimation
                                    sequence={[
                                        "Front-end Development",
                                        1000,
                                        "Back-end Development",
                                        1000,
                                        "Full-Stack Development",
                                        1000,
                                    ]}
                                    wrapper="span"
                                    speed={60}
                                    style={{ display: "inline-block" }}
                                    repeat={Infinity}
                                />
                            </span>
                            <br />
                            I'm here to make your digital dreams a stunning
                            reality.
                        </p>

                        <Link to='/my-projects' className='hover:text-white no-underline hover:no-underline '><button className="py-3 bg-white w-[120px] lg:w-[139px] text-center rounded-[18px] md:px-3 text-black text-sm  md:text-base hidden lg:block hover:scale-105 transition-all duration-300 ">
                            {" "}
                            PROJECTS{" "}
                        </button></Link>
                    </div>
                    <img
                        src={myPic}
                        alt=""
                        className="h-[250px] sm:h-[330px] md:h-[440px] lg:h-[540px] xl:h-[600px]   relative bottom-8 md:bottom-5 "
                        data-aos='fade-up' data-aos-offset='100' data-aos-delay='300'
                        
                    />
                   
                </div>
            </div>
        </Parallax>
    );
};

export default Hero;
